import * as React from 'react';

import { LazyLoad } from '@cian/lazyload-component';

import * as styles from './Image.css';

import { NoPhotoImage } from './NoPhotoImage';
import { ImageSimple } from './ImageSimple';

export interface IImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  lazy?: boolean;
  lazyOnViewport?: boolean;
  noEmptyImage?: boolean;
  src?: string;
  alt?: string;
}

export class Image extends React.Component<IImageProps> {
  public render() {
    const { lazy, lazyOnViewport, noEmptyImage, ...rest } = this.props;

    if (!rest.src && !noEmptyImage) {
      return (
        <div className={styles['iamge--empty']}>
          <NoPhotoImage />
        </div>
      );
    } else if (lazyOnViewport) {
      return (
        <LazyLoad
          onLoad={() => Promise.resolve()}
          renderEmpty={() => <ImageSimple {...rest} loadingStatus />}
          renderLoaded={() => <ImageSimple {...rest} />}
        />
      );
    } else if (lazy && !noEmptyImage) {
      return <ImageSimple {...rest} />;
    }

    return <img className={styles['image--simple']} {...rest}/>;
  }
}
